<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row justify="center" align="center" style="height: 400px;">
          <v-col cols="12" class="text-center">
            <p class="headline text--secondary">No tienes permisos suficientes contactate con tu administrador</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { userInfo } from '../mixins'

export default {
  name: 'NotAllowedPage',
  mixins: [userInfo]
}
</script>

<style >
</style>
